'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLongCurrency = exports.getCurrencyDescription = exports.getCurrencies = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ifeisIsomorphic = require('ifeis-isomorphic');

var getCurrencies = exports.getCurrencies = function getCurrencies() {
  return _extends({}, _ifeisIsomorphic.currencies);
};

var getCurrencyDescription = exports.getCurrencyDescription = function getCurrencyDescription(feisCurrencyCode) {
  return _ifeisIsomorphic.currencies[feisCurrencyCode].description;
};

var getLongCurrency = exports.getLongCurrency = function getLongCurrency(feisCurrencyCode) {
  return _ifeisIsomorphic.currencies[feisCurrencyCode].longSymbol;
};


//////////////////
// WEBPACK FOOTER
// ./common/utils/currencies.js
// module id = 62
// module chunks = 0